// Copyright 2021-2024, 2026 - Hewlett Packard Enterprise Company
import { useHistory } from 'react-router-dom';
import { AuthConsumer } from '../contexts/AuthContext';
import { postLoginRedirect } from '../utils/authHelpers';
import { COM_TAB_MARKER_PREFIX } from '../constants/authConst';

export default function AuthCallback() {
  const history = useHistory();
  return (
    <AuthConsumer>
      {({ signinRedirectCallback }) => {
        signinRedirectCallback()
          .then(() => {
            window.name = `${COM_TAB_MARKER_PREFIX}${window.indigo.REACT_APP_COM_API_ROOT_URL}`;
            postLoginRedirect(history);
          })
          .catch(() => {
            // TODO: Possibly display an error message with a link to GLP login page.
            // eslint-disable-next-line no-console
            console.log('Unable to authenticate user. Redirect to CCS login');
          });
        return <span>Authenticating ...</span>;
      }}
    </AuthConsumer>
  );
}
